/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { CustomFieldListBusinessService } from '../../resources/custom-field-list-business.service';
import { CustomFieldDetailsDialogComponent } from './custom-field-details-dialog.component';

export const customFieldDetailsDialog = createDialogRoute({
  component: CustomFieldDetailsDialogComponent,
  init: CustomFieldListBusinessService,
});
